import "./App.css";
import { Route, Routes, Link } from "react-router-dom";
import { Home } from "./pages/Home";
import { Private } from "./pages/Private";
import { RequireAuth } from "./contexts/Auth/RequireAuth";
import { useContext } from "react";
import { AuthContext } from "./contexts/Auth/AuthContext";
import { Called } from "./pages/call";
import { Login } from "./pages/Login";
import { Practitioner } from "./pages/Practitioner";

function App() {
  const auth = useContext(AuthContext);

  return (
    <>
      <div className="App">
        <Routes>
          <Route
            path="/called"
            element={
              <RequireAuth>
                <Called />
              </RequireAuth>
            }
          ></Route>

          <Route path="/" element={<Login />}></Route>
          <Route
            path="/practitioner"
            element={<Practitioner></Practitioner>}
          ></Route>
        </Routes>
        <hr />
      </div>
    </>
  );
}

export default App;
